import React from 'react';
import { Grid, TableBody, TableCell, TableHead, TableRow, withStyles } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import axiosInstance, { WEB_API, EVENT_ID, F_EMAIL } from '../constatns';
import { speakerAction } from './SpeakerAction';
import SubTitle from '../components/Text/SubTitle';
import Table from '../components/Table/Table';
import ConfirmButton from '../components/Button/ConfirmButton';

import swal from '@sweetalert/with-react';

const styles = (theme) => ({
  tableBody: {
    '& th': {
      width: '25%',
      color: '#555',
    },
    '& td': {
      width: '75%',
      color: '#555',
    },
  },
  filePreview: {
    cursor: 'pointer',
    textDecorationLine: 'underline',
    textDecorationColor: 'blue',
    color: 'blue',
  },
});

class SpeakerSubmissionConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      isSubmitting: false,
      data: this.props.data,
    };
  }

  onSubmit() {
    this.setState({ isSubmitting: true });
    // if (this.props.data.noteContent === '') {
    //   swal('Please submit after completing the body text.');
    // }

    speakerAction(this.props, 'modify', this.props.data.id, true, true)
      .then((result) => {
        axiosInstance
          .post(
            `${WEB_API}/speaker/speakerSubmitEmail?evt=${EVENT_ID}&speakerId=${this.props.data.id}&toEmail=${
              this.props.data.email
            }&templateName=${'SpeakerSubmitPRS2021'}&from=${F_EMAIL}`,
          )
          .then(() => {});
        // axiosInstance.post(`${WEB_API}/speaker/speakerSubmitEmail?evt=${EVENT_ID}&speakerId=${this.props.data.id}`).then(() => {});
        swal('Your submission is registered successfully.', {
          icon: 'success',
        }).then(() => {
          if (this.props.isRegister) {
            this.props.movePage('/speaker/guide');
          } else {
            this.props.handleClose();
          }
        });
      })
      .catch((_err) => {
        console.error(_err);
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  }

  openPreview(file) {
    window.open(`${file.path}`, '_blank');
  }

  renderFigures(data) {
    const { classes } = this.props;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>
              Figures Upload <span style={{ color: 'inherit', fontWeight: 500 }}>(format : jpg, png, gif)</span>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={classes.tableBody}>
          <TableRow>
            <TableCell component={'th'} width="25%">
              Figures 1
            </TableCell>
            <TableCell width="75%">
              <Grid container direction="column">
                <Grid item onClick={() => this.openPreview(data.figures1)} className={classes.filePreview}>
                  {data.figures1 && data.figures1.name}
                </Grid>
                <Grid item>{data.figuresMemo1 && data.figuresMemo1}</Grid>
              </Grid>
            </TableCell>
          </TableRow>
          {/* {data.figures2 && ( */}
          <TableRow>
            <TableCell component={'th'} width="25%">
              Figures 2
            </TableCell>
            <TableCell width="75%">
              <Grid container direction="column">
                <Grid item onClick={() => this.openPreview(data.figures2)} className={classes.filePreview}>
                  {data.figures2 && data.figures2.name}
                </Grid>
                <Grid item>{data.figuresMemo2 && data.figuresMemo2}</Grid>
              </Grid>
            </TableCell>
          </TableRow>
          {/* )} */}
          {/* {data.figures3 && ( */}
          <TableRow>
            <TableCell component={'th'} width="25%">
              Figures 3
            </TableCell>
            <TableCell width="75%">
              <Grid container direction="column">
                <Grid item onClick={() => this.openPreview(data.figures3)} className={classes.filePreview}>
                  {data.figures3 && data.figures3.name}
                </Grid>
                <Grid item>{data.figuresMemo3 && data.figuresMemo3}</Grid>
              </Grid>
            </TableCell>
          </TableRow>
          {/* )} */}
          {/* {data.figures4 && ( */}
          <TableRow>
            <TableCell component={'th'} width="25%">
              Figures 4
            </TableCell>
            <TableCell width="75%">
              <Grid container direction="column">
                <Grid item onClick={() => this.openPreview(data.figures4)} className={classes.filePreview}>
                  {data.figures4 && data.figures4.name}
                </Grid>
                <Grid item>{data.figuresMemo4 && data.figuresMemo4}</Grid>
              </Grid>
            </TableCell>
          </TableRow>
          {/* )} */}
          {/* {data.figures5 && ( */}
          <TableRow>
            <TableCell component={'th'} width="25%">
              Figures 5
            </TableCell>
            <TableCell width="75%">
              <Grid container direction="column">
                <Grid item onClick={() => this.openPreview(data.figures5)} className={classes.filePreview}>
                  {data.figures5 && data.figures5.name}
                </Grid>
                <Grid item>{data.figuresMemo5 && data.figuresMemo5}</Grid>
              </Grid>
            </TableCell>
          </TableRow>
          {/* )} */}
          {/* {data.figures6 && ( */}
          <TableRow>
            <TableCell component={'th'} width="25%">
              Figures 6
            </TableCell>
            <TableCell width="75%">
              <Grid container direction="column">
                <Grid item onClick={() => this.openPreview(data.figures6)} className={classes.filePreview}>
                  {data.figures6 && data.figures6.name}
                </Grid>
                <Grid item>{data.figuresMemo6 && data.figuresMemo6}</Grid>
              </Grid>
            </TableCell>
          </TableRow>
          {/* )} */}
        </TableBody>
      </Table>
    );
  }

  render() {
    const { classes, mode, data, abstractId } = this.props;
    // const { data } = this.state;
    console.log(this.props.data, 'dt');

    const spacing = (high) => {
      if (!this.props.isPop) {
        return (
          <Grid item xs={8}>
            <div style={{ height: high ? high : '20px' }} />
          </Grid>
        );
      }
    };

    return (
      <>
        <Grid item xs={mode && mode === 'review' ? 12 : 8}>
          <SubTitle>Abstract Submission Status</SubTitle>
          <Table>
            <TableBody className={classes.tableBody}>
              <TableRow>
                <TableCell component="th">
                  <span>*</span> Country
                </TableCell>
                <TableCell component="td">{data.country && data.country}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th">
                  <span>*</span> Name
                </TableCell>
                <TableCell component="td">
                  {data.firstName && data.firstName} {data.lastName && data.lastName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th">
                  <span>*</span> Affiliation
                </TableCell>
                <TableCell component="td">{data.affiliation && data.affiliation}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th">
                  <span>*</span> Email
                </TableCell>
                <TableCell component="td">{data.email && data.email}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th">
                  <span>*</span> Cell Phone No
                </TableCell>
                <TableCell component="td">
                  {data.countryCode && `+${data.countryCode}`}
                  {data.phoneNumber && `-${data.phoneNumber}`}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th">
                  {/* <span>*</span> */}
                  CV Upload
                </TableCell>
                <TableCell component="td">
                  <span className={classes.filePreview} onClick={() => this.openPreview(data.cvfile)}>
                    {data.cvfile && data.cvfile.name}
                  </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" colSpan={2} width={'100%'} style={{ textAlign: 'center', color: '#777777' }}>
                  {/* Lecture Note */}
                  Abstract
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th">
                  <span>*</span> Session
                </TableCell>
                <TableCell component="td">{data.session && data.session}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th">
                  <span>*</span> Title
                </TableCell>
                <TableCell component="td">{data.noteTitle && data.noteTitle}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th">
                  <span>*</span> Body
                </TableCell>
                <TableCell component="td">
                  {data.noteContent && (
                    <div dangerouslySetInnerHTML={{ __html: '<div style="display: inline;">' + data.noteContent + '</div>' }} />
                  )}
                </TableCell>
              </TableRow>

              {data.country.indexOf('Korea, Republic of') !== -1 ? (
                <TableRow>
                  <TableCell component="th">
                    <span>*</span> 개인노트북 사용 여부
                  </TableCell>
                  <TableCell component="td">{data.isUseLaptop && data.isUseLaptop === 'true' ? '사용' : '미사용'}</TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell component="th">
                    <span>*</span> Use own your Laptop
                  </TableCell>
                  <TableCell component="td">{data.isUseLaptop && data.isUseLaptop === 'true' ? 'Use' : 'Not Used'}</TableCell>
                </TableRow>
              )}
              {/* <TableRow>
                    <TableCell component="th">
                      <span>*</span> 동의항목 1
                    </TableCell>
                    <TableCell component="td">{data.check1 && data.check1 === 'true' ? '확인합니다.' : ''}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell component="th">
                      <span>*</span> 동의항목 2
                    </TableCell>
                    <TableCell component="td">
                      {data.check2 && data.check2 == 'true' && data.check2None && data.check2None === 'false' && '동의합니다.'}
                      {data.check2 && data.check2 == 'false' && data.check2None && data.check2None === 'true' && '동의하지 않습니다.'}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell component="th">
                      <span>*</span> 동의항목 3
                    </TableCell>
                    <TableCell component="td">
                      {data.check3 && data.check3 == 'true' && data.check3None && data.check3None === 'false' && '받았습니다.'}
                      {data.check3 && data.check3 == 'false' && data.check3None && data.check3None === 'true' && '해당사항 없음'}
                    </TableCell>
                  </TableRow> */}

              {data.country.indexOf('Korea, Republic of') !== -1 && (
                <>
                  <TableRow>
                    <TableCell component="th">
                      <span>*</span> 연자료 정보
                    </TableCell>
                    <TableCell component="td">
                      {data.accountHolder ? (
                        <>
                          <span>예금주 : {data.accountHolder}</span>
                          <br />
                        </>
                      ) : null}
                      {data.bank ? (
                        <>
                          <span>은행명 : {data.bank}</span>
                          <br />
                        </>
                      ) : null}
                      {data.bankAccount ? <span>계좌번호 : {data.bankAccount}</span> : null}
                    </TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </Grid>
        {spacing()}
        <Grid item xs={mode && mode === 'review' ? 12 : 8}>
          {this.renderFigures(data)}
        </Grid>
        {spacing()}
        <Grid item xs={mode && mode === 'review' ? 12 : 8}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {data.status && data.status === 'Complete' ? (
              <ConfirmButton
                color="secondary"
                onClick={() => {
                  if (mode && mode === 'review') {
                    this.props.handleMode();
                  } else {
                    this.props.handleState('abstractId', abstractId);
                    this.props.handleState('formState', 'modify');
                  }
                }}
              >
                Modify
              </ConfirmButton>
            ) : null}
            {!this.props.isPop && ((mode && mode === 'confirm') || data.status !== 'Complete') && (
              <>
                <div style={{ width: '20px' }} />
                <ConfirmButton
                  color="secondary"
                  onClick={() => {
                    this.onSubmit();
                  }}
                >
                  Submit
                </ConfirmButton>
              </>
            )}
            <div style={{ width: '20px' }} />
            <ConfirmButton
              size="large"
              variant="contained"
              disableElevation
              onClick={() => {
                if (mode && mode === 'review') {
                  this.props.handleClose();
                } else {
                  this.props.movePage('/speaker/guide');
                }
              }}
            >
              {/* {data.status && data.status === 'Complete' ? 'Confirm' : 'Cancel'} */}
              Cancel
            </ConfirmButton>
          </div>
        </Grid>
        {this.state.isSubmitting && (
          <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
            <CircularProgress size={100} thickness={5} style={{ color: this.props.theme.palette.secondary.point }} />
          </div>
        )}
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SpeakerSubmissionConfirm);
